import { Hierarchy } from '@prisma/client';
import * as yup from 'yup';

import InvoiceLineItemShape from './InvoiceLineItemShape.validation';

const AddCreditNoteValidationSchema = yup.object().shape({
    invoiceTo: yup
        .object()
        .shape({
            id: yup.number(),
            value: yup.string(),
        })
        .nullable(),
    invoiceToType: yup
        .string()
        .oneOf([Hierarchy.PARTNER, Hierarchy.MERCHANT], 'Required')
        .required('Required'),
    creditNoteItems: yup
        .array()
        .of(InvoiceLineItemShape)
        .min(1, 'Provide at least one line item')
        .required('Required')
        .test(
            'conditional-amount-validation',
            'At least one line item is required',
            (lineItems) => {
                if (!lineItems || lineItems.length === 0) return false; // already handled by min(1)

                // Check if any line item has any amount > 0
                const anyItemHasAmount = lineItems.some((item) => {
                    return [item.netAmount, item.totalNet, item.totalVat, item.lineTotal].some(
                        (val) => {
                            return val > 0;
                        }
                    );
                });

                // If any item has amount > 0, relax validation — pass the test
                if (anyItemHasAmount) return true;

                // If none has amounts > 0, then all line items must have all amounts > 0
                const allItemsHaveAllAmounts = lineItems.every((item) => {
                    return [item.netAmount, item.totalNet, item.totalVat, item.lineTotal].every(
                        (val) => {
                            return val > 0;
                        }
                    );
                });

                return allItemsHaveAllAmounts;
            }
        ),
    reason: yup.string().required('Required'),
});

export default AddCreditNoteValidationSchema;
